module.exports = __webpack_public_path__ + "img/2016tuanjian.67eb2659.png";